import { KeyInfoEmailField } from '@dap/sanity/types';
import { Stack, Typography, useTheme } from '@mui/material';
import InlineExternalLink from '../InlineExternalLink';

interface Props {
  value: Omit<KeyInfoEmailField, '_type'>;
}

// const linkIconStyle: SxProps<Theme> = { mr: 2, width: '14px', height: '14px' };

export default function KeyInfoEmail(props: Props) {
  const { breakpoints } = useTheme();
  const { value, title } = props.value;
  const href = value.startsWith('mailto:') ? value : `mailto:${value}`;

  return (
    <Stack>
      <Typography variant="h6" component="h3">
        {title}
      </Typography>
      <InlineExternalLink
        variant="body2"
        href={href}
        noWrap
        sx={{
          [breakpoints.down('md')]: {
            maxWidth: 'calc(100vw - 64px)',
          },
        }}
      >
        {value}
      </InlineExternalLink>
    </Stack>
  );
}
